/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MarkSentRequest interface.
 */
export function instanceOfMarkSentRequest(value) {
    if (!('wasEdited' in value) || value['wasEdited'] === undefined)
        return false;
    return true;
}
export function MarkSentRequestFromJSON(json) {
    return MarkSentRequestFromJSONTyped(json, false);
}
export function MarkSentRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'wasEdited': json['wasEdited'],
    };
}
export function MarkSentRequestToJSON(json) {
    return MarkSentRequestToJSONTyped(json, false);
}
export function MarkSentRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'wasEdited': value['wasEdited'],
    };
}
